import { useCallback } from 'react';
import { MembersTableContainer } from '@/components/members/members-table-container';
import { useOrgStore } from '@/stores/org-store';
import { getAllMembersByOrg } from '@/services/members/get-all-members-by-org';

export const MembersPage = () => {
  const { currentOrg } = useOrgStore();

  const fetchMembers = useCallback(async () => {
    try {
      const response = await getAllMembersByOrg(currentOrg?.orgid || '');

      return response;
    } catch (error) {
      console.error('Get all members error:', error);
      return { detail: 'Failed to fetch members' };
    }
  }, [currentOrg]);

  return (
    <MembersTableContainer
      title='Members'
      description='Manage who has access to your organization. Invite new members by email, track existing ones, and keep your team’s workspace up to date.'
      fetchMembers={fetchMembers}
    />
  );
};
